import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ScrollToHashElementLink } from './Utils/ScrollToHashElement.js';

class Home extends Component {
  render() {
    return (
      <div className="page page1">
        <div className="header">
          <div className="logo">
            <h2>Henserver</h2>
          </div>
          <div className="navigation-links">
            <ScrollToHashElementLink className="navigation-link" href="#about">About</ScrollToHashElementLink>
            <ScrollToHashElementLink className="navigation-link" href="#workshops">Workshops</ScrollToHashElementLink>
            <ScrollToHashElementLink className="navigation-link" href="#gallery">Gallery</ScrollToHashElementLink>
            <ScrollToHashElementLink className="navigation-link" href="#essays">Essays</ScrollToHashElementLink>
          </div>
        </div>
        <div className="site-title-section">
          <h1>Ryan Henao</h1>
          <p>Creative Psychology - Expressive Arts - Enviornmental Consciousness</p>
        </div>
      </div>
    );
  }
}

export default Home;
